document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(".header__inline-menu .mega-menu").forEach(function(element){
      element.addEventListener('mouseover', () => { 
        element.setAttribute('open', 'true');
      });
   
      element.addEventListener('mouseout', () => {
        element.removeAttribute('open');
      });
    });
  
    document.querySelectorAll(".mega-menu__list .mega-menu__link--level-2").forEach(function(element) {
      element.addEventListener('mouseover', () => {
        document.querySelectorAll('.mega-menu__list .active').forEach( (child) => {
          child.classList.remove('active');
        })
        element.parentNode.classList.add('active');
      })
    })
    
    document.querySelectorAll("header-menu summary.header__menu-item").forEach(function(element) {
      element.addEventListener('mouseover', () => {
        document.querySelectorAll('.mega-menu__list .active').forEach( (child) => {
          child.classList.remove('active');
        })
        element.nextElementSibling.querySelector('.mega-menu__content .mega-menu__list li:first-child').classList.add('active');
      })
    })
  
});
  
  
$('body').on( 'change', '.product-variants', function() {
    console.log(this);
    var removeline = $(this).data('id')
    var colourVariant = $(this).parent().find('.Colour').val();
    var sizeVariant = $(this).parent().find('.Size').val();
    var sizeAndColourVariant = $(this).parent().find('#ProductSelect-product-template');
    var quantity = $(this).parent().parent().prev().find('.quantity__input').val();
  
    console.log('To Remove Line : ' + removeline);
    console.log('Colour : ' + colourVariant);
    console.log('Size : ' + sizeVariant);
    console.log('Quantity : ' + quantity);
    console.log(sizeAndColourVariant);
  
    console.log('Create New Cart Item');
  
    let selectedVariant = "";
    let addLine = "";
    let variantAvailable = true;
    document.querySelectorAll("#ProductSelect-product-template-"+removeline+" option").forEach( (variantData) => {
  
      if(sizeVariant != "" && colourVariant === undefined) {
        selectedVariant = sizeVariant;
      } else if(sizeVariant === undefined && colourVariant != "") {
        selectedVariant = colourVariant;
      }
  
      if(sizeVariant != undefined && colourVariant != undefined) {
        selectedVariant = ""+sizeVariant+" / "+colourVariant+"";
      } 
  
      if(selectedVariant == variantData.text) {
        variantAvailable = variantData.dataset.availability;
        addLine = variantData.value;
      }
    });
    console.log(addLine)
  
    if(variantAvailable == "true" && addLine != removeline) {
      document.querySelector('.errorMessage-'+removeline+'').innerHTML = "Updating your cart item...";
      $.ajax({
        url: "/cart/add.js",
        data: {
          items: [{
            id: addLine,
            quantity: quantity
          }]
        },                
        type: "POST",
        success: function(data) {
            //remove the old line             
          console.log('Success Adding on Cart');
          itemRemove(removeline);
        },
        error: function (xhr, ajaxOptions, thrownError) {
          if (xhr.status == 200) {
  
            console.log('Success Adding on Cart (2)');
            itemRemove(removeline);
          } else {
            obj = JSON.parse(xhr.responseText);
          }
  
        }
      });
    } else if (addLine==removeline) {
      document.querySelector('.errorMessage-'+removeline+'').innerHTML = "";
    } else {
      document.querySelector('.errorMessage-'+removeline+'').innerHTML = "Variant is not available."
    }
  });
  
  function itemRemove(removeline){
    console.log('Removing line item:'+removeline);
    $.ajax({
       url: "/cart/change.js",
       data: {
          id:  removeline,
          quantity: 0
       },        
       type: "POST",     
       success: function(data){
          location.reload();
       },
       error: function (xhr, ajaxOptions, thrownError) {
        if (xhr.status == 200) {
  
          console.log('Success Removing on Cart (2)');
          itemRemove(removeline);
  
        } else {
          obj = JSON.parse(xhr.responseText);
        }
        location.reload();
  
      }
   });         
  }

// faq search and filter 
document.addEventListener('DOMContentLoaded', function() {
  const filterTabs = document.querySelectorAll('.filter-tab');
  const faqSections = document.querySelectorAll('.c-faqs-section');

  faqSections.forEach((section) => {
    section.parentElement.style.display = 'none';
  });

  filterTabs[0].classList.add('active');
  faqSections[0].parentElement.style.display = 'block';

  filterTabs.forEach((tab) => {
    // add active class on click
    tab.addEventListener('click', () => {
      const searchField = document.querySelector('#c-search-faqs');
      const resultsCon = document.querySelector('.c-search-results-container');

      // remove active class from all tabs
      filterTabs.forEach((tab) => {
        tab.classList.remove('active');
      });

      tab.classList.add('active');
      resultsCon.style.display = 'none';
      searchField.value = '';
      faqSection.forEach((section) => section.style.display = 'block');
      
      // show faq section that matches the category and
      faqSections.forEach((section) => {
        if (section.dataset.category === tab.dataset.category) {
          section.parentElement.style.display = 'block';
          
        } else{
          section.parentElement.style.display = 'none';
        }
      });
    });
  });

  const searchInput = document.querySelector('#c-search-faqs');
  const searchForm = document.getElementById('.c-faq-search-banner__form');
  const searchButton = document.querySelector('#submitSearch');
  const searchResultContainer = document.createElement('section');
  const searchResultInner = document.createElement('div');
  const noResults = document.createElement('p');
  const faqSection = document.querySelectorAll('.c-faqs-section');
  const faqs = document.querySelectorAll('.c-faqs-wrapper .faq');
  const faqFilter = document.querySelector('.c-faq-filter');

  searchResultContainer.classList.add('c-search-results-container');
  searchResultInner.classList.add('c-search-results-inner');
  searchResultInner.classList.add('page-width');
  noResults.classList.add('no-results');
  noResults.classList.add('brandon-grotesque');
  noResults.textContent = 'No results found';
  noResults.style.textAlign = 'center';
  noResults.style.display = 'none';

  faqSection[0].parentElement.insertAdjacentElement('beforebegin', searchResultContainer);
  searchResultContainer.appendChild(searchResultInner);
  searchResultContainer.appendChild(noResults);

  // clone and append all faqs to search result inner and hide initially
  faqs.forEach((faq) => {
    const faqClone = faq.cloneNode(true);
    searchResultContainer.style.display = 'none';
    searchResultInner.appendChild(faqClone);
  });

  function updateActiveClass() {
    const searchValue = searchInput.value.trim();

    if (searchValue.length > 0) {
      filterTabs.forEach((tab) => {
        tab.classList.remove('active');
      });
    } else if (searchValue.length === 0) {
      filterTabs[0].classList.add('active');
      faqSections.forEach((section) => {
        if (section.dataset.category === filterTabs[0].dataset.category) {
          section.parentElement.style.display = 'block';
        } else {
          section.parentElement.style.display = 'none';
        }
      });
    }
  }


  function searchHandler() {
    const searchValue = searchInput.value.toLowerCase();

    searchValue.length > 0 ? searchResultContainer.style.display = 'block' : searchResultContainer.style.display = 'none';
    searchValue.length > 0 ? faqSection.forEach((section) => section.style.display = 'none') : faqSection.forEach((section) => section.style.display = 'block');

    const faqWrapper = document.querySelectorAll('.c-search-results-inner .faq');
    const faqTitle = document.querySelectorAll('.c-search-results-inner .faq .faq__question h4');
    const faqDescription = document.querySelectorAll('.c-search-results-inner .faq .faq__answer p');

    faqTitle.forEach((faqTitle, index) => {
      const faqTitleText = faqTitle.textContent.toLowerCase();
      const contentText = faqDescription[index].textContent.toLowerCase();
      const svg = faqTitle.querySelector('span');

      const titleMatchIndex = faqTitleText.indexOf(searchValue);
      const contentMatchIndex = contentText.indexOf(searchValue);

      faqTitle.classList.add('brandon-grotesque');

      if (titleMatchIndex !== -1) {
        const titleMatchedText = faqTitle.textContent.slice(titleMatchIndex, titleMatchIndex + searchValue.length);
        faqTitle.innerHTML = faqTitle.textContent.replace(titleMatchedText, `<u>${titleMatchedText}</u>`);
      }

      if (contentMatchIndex !== -1) {
        const contentMatchedText = faqDescription[index].textContent.slice(contentMatchIndex, contentMatchIndex + searchValue.length);
        faqDescription[index].innerHTML = faqDescription[index].textContent.replace(contentMatchedText, `<u>${contentMatchedText}</u>`);
      }

      var isMatch = titleMatchIndex !== -1 || contentMatchIndex !== -1;

      if (isMatch) {
        if (faqTitle.querySelector('span') === null) {
          faqTitle.innerHTML += `
          <span>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.88965 15.754L12.8896 9.75397L18.8896 15.754" stroke="#211D1D" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>`;
        }
      }

      faqWrapper[index].classList.toggle('open', isMatch);

      if (isMatch) {
        faqWrapper[index].style.display = 'block';
      } else {
        faqWrapper[index].style.display = 'none';
      }
    });

    // show no results if no faqs match
    const faqWrapperVisible = document.querySelectorAll('.c-search-results-inner .faq[style="display: block;"]');
    faqWrapperVisible.length === 0 ? noResults.style.display = 'block' : noResults.style.display = 'none';
  };

  searchInput.addEventListener('keyup', (e) => {
    if (e.target.value.length === 0) {
      faqSection.forEach((section) => section.style.display = 'block');
      searchResultContainer.style.display = 'none';
      updateActiveClass();
    }
  });

  searchInput.addEventListener('keydown', (e) => {
    if (e.keyCode === 13 || e.key === 'Enter') {
      searchHandler();
      searchInput.blur();
      setTimeout(() => {
        searchButton.click();
      }, 500);
      faqFilter.scrollIntoView({
        behavior: 'smooth'
      });
      updateActiveClass();
    }
  });

  searchButton.addEventListener('click', (e) => {
    e.preventDefault();
    searchHandler();
    searchInput.blur();
    faqFilter.scrollIntoView({
      behavior: 'smooth'
    });
    updateActiveClass();
  });

  // open and close faq results
  const faqResultsHeading = document.querySelectorAll('.c-search-results-container .c-search-results-inner .faq__question');
  faqResultsHeading.forEach((faq) => {
    faq.addEventListener('click', () => {
      faq.parentElement.classList.toggle('open');

      const svg = faq.querySelector('span');
      faq.parentElement.classList.contains('open') ? svg.style.transform = 'rotate(0deg)' : svg.style.transform = 'rotate(180deg)';
    });
  });
});